export const user = {
    iduser: 'iduser',
    fullname : 'fullname',
    username: 'username',
    userinfo : 'userinfo',
    language : 'language',
    idle: 'idle'
};
export const workplaces = 'workplaces';
export const userSession = {
    iduser : 'iduser',    
    idorg : 'idorg',
    idbranch : 'idbranch',
    idprofile: 'idprofile',
    username : 'username',
    languageCve : 'languageCve',
    formsByLanCveAndOrgId : 'formsByLanCveAndOrgId',
    holidayDay : 'holidayDay',
    procedure : 'procedure',
    listLockTypes : 'listLockTypes',
    vitalSignsByBranchOffId : 'vitalSignsByBranchOffId',
    vitalSign : 'vitalSign',
    catalogUnits : 'catalogUnits',
    catalogUnitiesMeasurement : 'catalogUnitiesMeasurement',
    catalogVitalSignsType : 'catalogVitalSignsType',
    catalogOptionSex : 'catalogOptionSex',
    catalogClueAge : 'catalogClueAge',
    inactivityTime: 'inactivityTime',
    endTimeBlockedSession: 'endTimeBlockedSession',
    sexType : 'sexType',
    clueAge : 'clueAge',
    procedureType : 'procedureType',
    procedureUpdate : 'procedureUpdate',
    proceduresByBranchOffId : 'proceduresByBranchOffId',
};